export default __webpack_public_path__ + "static/media/D63C8D18-54C6-4927-8E5F-ECCBB6C991BE_1_105_c.6d772fac.jpeg";